import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import Home from "../pages/Home";
import StartBrand from "../pages/StartBrand";
import PrivacyPolicy from "../pages/policy/PrivacyPolicy";
import AdminLogin from "../pages/admin/AdminLogin";
import AdminDashboard from "../pages/admin/AdminDashboard";
import ProtectedRoute from "../components/admin/ProtectedRoute";

export const router = createBrowserRouter([
    {
        path: "/",
        element: <App />, 
        children: [
            {
                index: true,
                element: <Home />,
            },
            {
                path: "start-brand",
                element: <StartBrand />,
            },
            {
                path: "/privacy-policy",
                element: <PrivacyPolicy />,
            }
        ],
    },
    {
        path: "/admin",
        element: <AdminLogin />,
    },
    {
        path: "/admin/dashboard",
        element: (
            <ProtectedRoute>
                <AdminDashboard />
            </ProtectedRoute>
        ),
    },
]);
